export const USERS_MODULE = 'usuarios'
export const PASSWORD_EMAIL_TYPE = 'usuarios_crear_contrasena'

export function isFixedCtaType(emailType) {
  return emailType === PASSWORD_EMAIL_TYPE
}

export const MODULES = {
  liderazgo: {
    name: 'Liderazgo',
    color: '#5e2ca5',
    moduleTag: 'Líderes PHD'
  },
  clima: {
    name: 'Clima',
    color: '#00a0dc',
    moduleTag: 'CL7 · Clima laboral'
  },
  cultura: {
    name: 'Cultura',
    color: '#2ecc71',
    moduleTag: 'Diagnóstico de cultura'
  },
  usuarios: {
    name: 'Usuarios/Plataforma',
    color: '#f39c12',
    moduleTag: 'Usuarios'
  }
}

export const EMAIL_TYPES = {
  liderazgo: [
    { key: 'liderazgo_encuesta_lider', label: 'Autoevaluación (líder)' },
    { key: 'liderazgo_encuesta_colaborador', label: 'Evaluación (colaboradores)' },
    { key: 'liderazgo_resultados', label: 'Resultados disponibles' }
  ],
  clima: [
    { key: 'clima_encuesta', label: 'Invitación a encuesta' },
    { key: 'clima_recordatorio', label: 'Recordatorio' },
    { key: 'clima_recordatorio_50', label: 'Recordatorio +50% participación' }
  ],
  cultura: [
    { key: 'cultura_encuesta', label: 'Invitación a encuesta' },
    { key: 'cultura_recordatorio', label: 'Recordatorio' }
  ],
  usuarios: [
    { key: 'usuarios_crear_contrasena', label: 'Creación de contraseña' }
  ]
}

export const PLACEHOLDERS = [
  {
    key: 'nombre',
    placeholder: '{NOMBRE}',
    label: 'Nombre',
    example: 'María',
    color: '#3b82f6',
    icon: 'account_circle'
  },
  {
    key: 'empresa',
    placeholder: '{NOMBRE_EMPRESA}',
    label: 'Empresa',
    example: 'Acme Corp',
    color: '#10b981',
    icon: 'business'
  }
]

export function getEmailTypesForModule(module) {
  return EMAIL_TYPES[module] || []
}

export function getModuleConfig(module) {
  return MODULES[module] || null
}

export function serializeContent(html) {
  if (!html) return ''

  let result = html
    .replace(/<span[^>]*class="[^"]*placeholder-chip[^"]*nombre[^"]*"[^>]*>[\s\S]*?<\/span>/gi, '{NOMBRE}')
    .replace(/<span[^>]*class="[^"]*placeholder-chip[^"]*empresa[^"]*"[^>]*>[\s\S]*?<\/span>/gi, '{NOMBRE_EMPRESA}')

  result = result
    .replace(/<div><br><\/div>/gi, '\n')
    .replace(/<div>/gi, '\n')
    .replace(/<\/div>/gi, '')
    .replace(/<br\s*\/?>/gi, '\n')

  const temp = document.createElement('div')
  temp.innerHTML = result
  result = temp.textContent || temp.innerText || ''

  return result
}

export function deserializeContent(text) {
  if (!text) return ''

  let result = text
    .replace(/{NOMBRE}/g, buildChipHtml('nombre'))
    .replace(/{NOMBRE_EMPRESA}/g, buildChipHtml('empresa'))

  result = result.replace(/\n/g, '<br>')

  return result
}

function buildChipHtml(type) {
  const config = PLACEHOLDERS.find(p => p.key === type)
  if (!config) return ''

  return `<span class="placeholder-chip ${type}" contenteditable="false">${config.label}</span>`
}

export function replacePlaceholdersForPreview(text, empresaNombre, nombreUsuario) {
  if (!text) return ''

  const nombre = nombreUsuario || 'Usuario'
  const empresa = empresaNombre || 'Empresa Demo'

  return text
    .replace(/{NOMBRE}/g, nombre)
    .replace(/{NOMBRE_EMPRESA}/g, empresa)
}

export function getDefaultTemplate(emailType) {
  const defaults = {
    liderazgo_encuesta_lider: {
      subject: 'Líder PHD Autoevaluación',
      greeting: 'Hola {NOMBRE}',
      body: 'En {NOMBRE_EMPRESA} queremos que nuestros y nuestras líderes sean cada vez mejores. Por esto, iniciamos la valoración de tus competencias de liderazgo.\n\nTe pedimos que hagas tu autoevaluación. Tardarás entre 20 y 30 minutos. Asegúrate de tener tiempo suficiente y concentrarte solo en esta actividad.\n\nTu participación es muy importante. ¡Gracias!',
      cta: { enabled: true, text: 'Evalúate aquí', urlType: 'auto' },
      footerNote: 'Por favor no reenvíes este correo.'
    },
    liderazgo_encuesta_colaborador: {
      subject: 'Líder PHD Evaluación del líder',
      greeting: 'Hola {NOMBRE}',
      body: 'En {NOMBRE_EMPRESA} queremos que nuestros y nuestras líderes sean cada vez mejores. Por esto, iniciamos la valoración de sus competencias de liderazgo.\n\nTe pedimos que evalúes a tu jefe. Tardarás entre 20 y 30 minutos. Asegúrate de tener tiempo suficiente y concentrarte solo en esta actividad.\n\nTu participación es muy importante. ¡Gracias!',
      cta: { enabled: true, text: 'Ayuda a tu jefe a mejorar aquí', urlType: 'auto' },
      footerNote: 'Por favor no reenvíes este correo.'
    },
    liderazgo_resultados: {
      subject: 'Tus resultados de liderazgo están disponibles',
      greeting: 'Hola {NOMBRE}',
      body: '¡Tus resultados de la evaluación de liderazgo ya están disponibles!\n\nHaz clic en el botón para visualizar tu informe completo.',
      cta: { enabled: true, text: 'Ver mis resultados', urlType: 'auto' },
      footerNote: 'Este enlace es personal. Saludos del equipo de SIETE.'
    },
    clima_encuesta: {
      subject: 'Diagnóstico de Clima Organizacional',
      greeting: 'Hola {NOMBRE}',
      body: 'En {NOMBRE_EMPRESA} queremos ser cada vez mejores. Por esto, iniciamos la valoración de nuestro ambiente de trabajo.\n\nTe invitamos a que participes en el transcurso de esta semana. Tardarás entre 20 a 30 minutos aproximadamente. Asegúrate de disponer de este tiempo y concentrarte.\n\nTu participación es muy importante. ¡Gracias!',
      cta: { enabled: true, text: 'Ayúdanos a mejorar aquí', urlType: 'auto' },
      footerNote: 'Este enlace es personal e intransferible.'
    },
    clima_recordatorio: {
      subject: 'Recordatorio - Diagnóstico de Clima',
      greeting: 'Hola {NOMBRE}',
      body: 'Esperamos que estés muy bien. Desde {NOMBRE_EMPRESA} queremos recordarte que aún puedes completar nuestra encuesta de clima organizacional.\n\nTu opinión es muy importante para nosotros y nos ayuda a mejorar.',
      cta: { enabled: true, text: 'Responder encuesta', urlType: 'auto' },
      footerNote: 'Este enlace es personal e intransferible.'
    },
    clima_recordatorio_50: {
      subject: '¡La mayoría ya participó! - Diagnóstico de Clima',
      greeting: 'Hola {NOMBRE}',
      body: 'Más del 50% de tus compañeros en {NOMBRE_EMPRESA} ya completaron la encuesta de clima organizacional.\n\n¡No te quedes atrás! Tu opinión es muy importante para construir un mejor ambiente de trabajo.',
      cta: { enabled: true, text: 'Participar ahora', urlType: 'auto' },
      footerNote: 'Este enlace es personal e intransferible.'
    },
    cultura_encuesta: {
      subject: 'Diagnóstico de Cultura',
      greeting: '¡Hola {NOMBRE}!',
      body: 'Somos Siete Gestión Humana y Organizacional.\n\nTu organización {NOMBRE_EMPRESA} quiere conocer cómo es su cultura, y nosotros los acompañaremos en el proceso.\n\nTus conocimientos son muy valiosos para que podamos identificar ¿Cómo es la organización realmente? ¿Qué la caracteriza? ¿Qué la hace única?\n\nEsta es la oportunidad para que nos cuentes qué piensas, porque construir la cultura que deseamos es responsabilidad de todos.',
      cta: { enabled: true, text: 'Ingresar', urlType: 'auto' },
      footerNote: 'Este enlace es personal e intransferible.'
    },
    cultura_recordatorio: {
      subject: 'Recordatorio',
      greeting: '¡Hola {NOMBRE}!',
      body: 'Esperamos que estés muy bien. Desde {NOMBRE_EMPRESA} queremos recordarte que aún puedes completar nuestra encuesta.\n\nTu opinión es muy importante para nosotros y nos ayuda a mejorar.',
      cta: { enabled: true, text: 'Responder encuesta', urlType: 'auto' },
      footerNote: 'Este enlace es personal e intransferible.'
    },
    usuarios_crear_contrasena: {
      subject: 'Crea tu contraseña para ingresar a SIETE',
      greeting: 'Hola {NOMBRE}',
      body: 'Tu cuenta de {NOMBRE_EMPRESA} en la plataforma de SIETE ya está creada.\n\nHaz clic en el botón para crear tu contraseña e ingresar. El proceso toma unos segundos.',
      cta: { enabled: true, text: 'Crear contraseña', urlType: 'auto' },
      footerNote: 'Si el enlace ya venció, usa "¿Olvidaste tu contraseña?" en la pantalla de inicio de sesión para solicitar uno nuevo.'
    }
  }

  return defaults[emailType] || null
}



// WEBPACK FOOTER //
// ./src/components/shared/emailEditor/helpers.js